<script setup lang="ts">
defineProps<{
  product: any
  variantCollection: {
    items: any[]
    current: string
    key: string
  }
}>()

const limit = 4
const modalColors = useUiDialog('modal-colors')

const productImageUrl = (url: string, params: string) => {
  return `${url}${params}`
}
const link = (product: any) => {
  return `${product.url}`
}
</script>

<template>
  <div
    v-if="variantCollection.items.length > 1"
    class="variations variations--colors"
  >
    <div class="variations__heading">
      {{ $t('Color') }}
      {{ product?.color?.map((item) => item.label)?.join(', ') }}
    </div>

    <div class="variations__content">
      <ul class="variations__list">
        <li
          v-for="item in variantCollection.items.slice(0, limit)"
          :key="item.product.sku"
          class="variations__item"
        >
          <AppLink
            :to="link(item.product)"
            :class="{ variations__link: true, current: item.product.sku === variantCollection.current }"
          >
            <img
              :src="productImageUrl(item.product.image, '?f=rs:fit:96:115')"
              width="96"
              height="115"
              :alt="item.product.name"
              loading="lazy"
              class="variations__image"
            >
            <span class="variations__text">{{ item.value }}</span>
          </AppLink>
        </li>
      </ul>

      <button
        v-if="variantCollection.items.length > limit"
        type="button"
        class="variations__more"
        @click="modalColors.open"
      >
        +{{ variantCollection.items.length - limit }}
      </button>
    </div>

    <LazyUiDialog
      class="variants__modal"
      name="modal-colors"
      dialog-type="responsive"
    >
      <template #dialogHeader>
        <span class="dialog__title">{{ $t('Colors') }}</span>
      </template>

      <div class="variations variations--colors">
        <ul class="variations__list">
          <li
            v-for="item in variantCollection.items"
            :key="item.product.sku"
            class="variations__item"
          >
            <AppLink
              :to="link(item.product)"
              class="variations__link"
              :class="{ current: item.product.sku === variantCollection.current }"
              @click="modalColors.close"
            >
              <img
                :src="productImageUrl(item.product.image, '?f=rs:fit:96:115')"
                width="65"
                height="65"
                :alt="item.product?.color?.map((item) => item.label)?.join(', ')"
                loading="lazy"
                class="variations__image"
              >
              <span class="variations__label">
                {{ item.product?.color?.map((item) => item.label)?.join(', ') }}
              </span>
            </AppLink>
          </li>
        </ul>
      </div>
    </LazyUiDialog>
  </div>
</template>
